<template>
    <div id="pifu">
        <div class="iarea">
        <p style="font-size:22pt"><span lang=EN-US>&nbsp;</span></p>
        <p style="font-size:22pt"><span lang=EN-US>&nbsp;</span></p>
        <p style="font-size:22pt"><span lang=EN-US>&nbsp;</span></p>
        <p style="font-size:22pt"><span lang=EN-US>&nbsp;</span></p>
        <p align=center style='font-size:16pt;font-family:FangSong_GB2312;text-align:center !important;'>
            扬邗财发 〔<span class="number">{{openYear + 1}}</span>〕 <span class="number">{{writeNum}}</span>号
        </p>
        <p style="font-size:22pt"><span lang=EN-US>&nbsp;</span></p>
       <p align=center style='text-align: center !important;font-family:STZhongsong;font-size: 22pt;'>
           扬州市邗江区财政局关于{{data.divname}}<span class="number">{{openYear}}</span>年度部门{{openType}}的通知
        </p>
        <p style="font-size:12pt">&nbsp;</p>
        </div>
        <div class="iarea text">
        <p class="MsoNormal">{{data.divname}}：</p>
        <p class="suojin MsoNormal">
            <span class="number">{{openYear}}</span>年度区级部门{{openType}}已在<span class="number">9</span>月<span class="number">28</span>日经邗江区第十六届人民代表大会常务委员会第三十七次会议审议批准。根据《中华人民共和国预算法》，现将<span class="number">{{openYear}}</span>年度部门{{openType}}批复给你们，并就有关事项通知如下：
        </p>
         <p class="suojin MsoNormal">
            <span class="heiti"> 一、基本收支情况</span>
        </p>
         <p class="suojin MsoNormal">
            <span class="kaiti">（一）总收支。</span><span class="number">{{openYear}}</span>年度年初结转和结余<span class="number">{{tableData.a}}</span>万元，本年收入<span class="number">{{tableData.b}}</span>万元，本年支出<span class="number">{{tableData.c}}</span>万元，使用非财政拨款结余<span class="number">{{tableData.d}}</span>万元，结余分配<span class="number">{{tableData.e}}</span>万元，年末结转和结余<span class="number">{{tableData.f}}</span>万元。
        </p>
         <p class="suojin MsoNormal">
            <span class="kaiti">（二）一般公共预算财政拨款收支。</span><span class="number">{{openYear}}</span>年度一般公共预算财政拨款年初结转和结余<span class="number">{{tableData.g}}</span>万元，本年收入<span class="number">{{tableData.h}}</span>万元，本年支出<span class="number">{{tableData.i}}</span>万元，年末结转和结余<span class="number">{{tableData.j}}</span>万元。
        </p>
         <p class="suojin MsoNormal">
            <span class="kaiti">（三）政府性基金预算财政拨款收支。</span><span class="number">{{openYear}}</span>年度政府性基金预算财政拨款年初结转和结余<span class="number">{{tableData.k}}</span>万元，本年收入<span class="number">{{tableData.l}}</span>万元，本年支出<span class="number">{{tableData.m}}</span>万元，年末结转和结余<span class="number">{{tableData.n}}</span>万元。
        </p>
         <p class="suojin MsoNormal">
            <span class="kaiti">（四）国有资本经营预算财政拨款收支。</span><span class="number">{{openYear}}</span>年度国有资本经营预算财政拨款年初结转和结余<span class="number">0</span>万元，本年收入<span class="number">0</span>万元，本年支出<span class="number">0</span>万元，年末结转和结余<span class="number">0</span>万元。
        </p>
         <p class="suojin MsoNormal">
            <span class="heiti">二、相关工作要求</span>
        </p>
         <p class="suojin MsoNormal">
            <span class="kaiti">(一)做好所属单位{{openType}}批复工作</span>
        </p>
         <p class="suojin MsoNormal">
            你单位应当在接到本批复后<span class="number">15</span>日内，向所属单位批复{{openType}}。
        </p>
         <p class="suojin MsoNormal">
            <span class="kaiti">(二)按时公开{{openType}}</span>
        </p>
         <p class="suojin MsoNormal">
            除涉密单位和事项外，你单位当在接到批复后的<span class="number">20</span>日内，按照本批复的{{openType}}数据和规定格式向社会公开本部门{{openType}}。
        </p>
        </div>
        <div class="iarea text">
                <p class="MsoNormal" align=right style="text-align:right !important">&nbsp;</p>
                <p class="MsoNormal" align=right style="text-align:right !important">&nbsp;</p>
                <p class="MsoNormal" align=right style="text-align:right !important">扬州市邗江区财政局</p>
                <p class="MsoNormal" align=right style="text-align:right !important"><span class="number">{{openYear + 1}}</span>年<span class="number">10</span>月<span class="number">12</span>日</p>
            </div>
    </div>
</template>

<script>
    import $ from 'jquery'
    import { getDivList, getDivsList } from '@/api/index.js'
    import "@/api/jquery.hanjiangwordexport.js"
    export default {
        data() {
            return {
                data: {},
                divid: '',
                tableData: {},
                writeNum: 115,
                openType:this.$store.state.openType == 'js' ? '决算' : '预算',
                openYear:this.$store.state.openYear,
            }
        },
        created() {
            this.divid = this.$route.query.divid
            this.init()
        },
        methods: {
            async init() {
                let divs = await getDivsList()
                let arr = divs.divs.filter((e) => e.type!=1).sort(function (a, b) {
                    return a.autoid - b.autoid
                })
                for (var i = 0; i < arr.length; i++) {
                    if (arr[i].id == this.divid) {
                        this.writeNum = this.writeNum + i
                    }
                }
                this.after()
            },
            async after(){
                let res = await getDivList({ id: this.divid })
                if (res.status == 0) {
                    this.data = res
                    this.tableData.a = res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["28"].b ? this.isMoney(res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["28"].b) : 0  //表1的34B
                    this.tableData.b = res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["26"].b ? this.isMoney(res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["26"].b) : 0  //表1的32B
                    this.tableData.c = res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["26"].d ? this.isMoney(res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["26"].d) : 0  //表1的32D
                    this.tableData.d = res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["27"].b ? this.isMoney(res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["27"].b) : 0  //表1的33B
                    this.tableData.e = res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["27"].d ? this.isMoney(res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["27"].d) : 0  //表1的33D
                    this.tableData.f = res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["28"].d ? this.isMoney(res.tables.find(e => e.name == '1' && e.year==this.openYear && e.type==this.$store.state.openType).rows["28"].d) : 0  //表1的34D
                    this.tableData.g = res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["28"].b ? this.isMoney(res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["28"].b) : 0  //表4的35B
                    this.tableData.h = res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["0"].b ? this.isMoney(res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["0"].b) : 0  //表4的7B
                    this.tableData.i = res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["26"].d ? this.isMoney(res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["26"].e) : 0  //表4的33E
                    this.tableData.j = res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["27"].d ? this.isMoney(res.tables.find(e => e.name == '4' && e.year==this.openYear && e.type==this.$store.state.openType).rows["27"].d) : 0  //表4的34D
                    this.tableData.k = res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].e ? this.isMoney(res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].e) : 0 //表10的9E
                    this.tableData.l = res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].f ? this.isMoney(res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].f) : 0 //表10的9F
                    this.tableData.m = res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].g ? this.isMoney(res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].g) : 0 //表10的9G
                    this.tableData.n = res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].j ? this.isMoney(res.tables.find(e => e.name == '10' && e.year==this.openYear && e.type==this.$store.state.openType).rows['0'].j) : 0 //表10的9J

                    this.word()
                }
            },
            word() {
                this.$nextTick(() => {
             $("body").css("margin","0pt");
             $(".text p").css("font-size", "16pt").css("line-height", "30pt").css("font-family", "仿宋").css("margin", "0pt");
             $(".suojin").css("text-indent", "32.0pt");
             $(".heiti").css("font-family", "黑体");
             $(".kaiti").css("font-family", "楷体");
             $(".number").css("font-family", "Times New Roman");
              $(document.body).wordExport(this.data.divname);
                }, 1000);
            }
        }
    }
</script>

<style scoped>
    /* #pifu p {
        font-size: 21px;
        font-family: FangSong !important;
        line-height: 2em !important;
    }

    .title {
        text-align: center;
    }

    .text {
        text-indent: 2em
    }

    .center {
        text-align: center;
    }
    .right {
        text-align: right;
    }

    .bold {
        font-weight: bold;
    } */
</style>